import { styled } from '@mui/system';
import { Box, Typography, Button, IconButton } from '@mui/material';

export const StatusContainer = styled(Box)(({ theme }) => ({
  flex: '1 1 auto',
  width: '100%',
  background: 'radial-gradient(circle at top left, rgba(27, 0, 166, 0.2), black)',
  borderRadius: '16px',
  padding: theme.spacing(4),
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  height: '100%',
  overflow: 'hidden',
  gap: theme.spacing(1),
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '50%',
  '& > button': {
    width: '100%',
  },
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(10),
}));

export const TempoLogo = styled('img')(({ theme }) => ({
  height: '200px',
  zIndex: 1,
  filter: 'drop-shadow(0 4px 12px rgba(0, 132, 255, 0.2))',
}));

const BaseButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  maxWidth: '450px',
  height: '40px',
  borderRadius: '12px',
}));

export const ModalWrapper = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '400px',
  outline: 'none',
});

export const ModalContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  borderRadius: '16px',
  backgroundColor: theme.palette.background.secondary,
  boxShadow: '0 24px 48px rgba(0, 0, 0, 0.4)',
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  position: 'relative',
}));

export const ModalCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  width: '32px',
  height: '32px',
  color: theme.colors.gray,
  padding: 0,
  '&:hover': {
    backgroundColor: 'transparent',
    color: theme.colors.white,
  },
}));

export const ModalCloseIcon = styled('div')(({ theme }) => ({
  width: '20px',
  height: '20px',
  position: 'relative',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '2px',
    backgroundColor: 'currentColor',
    top: '50%',
    left: 0,
  },
  '&::before': {
    transform: 'rotate(45deg)',
  },
  '&::after': {
    transform: 'rotate(-45deg)',
  },
}));

export const ModalButton = styled(BaseButton)(({ theme }) => ({
  backgroundColor: theme.palette.info.main,
  color: theme.colors.white,
  '&:hover': {
    backgroundColor: theme.colors.blueHover,
    transform: 'translateY(-1px)',
  },
  '&:not(:last-child)': {
    marginBottom: theme.spacing(1),
  },
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  color: 'white',
  textAlign: 'center',
  marginBottom: theme.spacing(3),
  fontSize: '20px',
  fontWeight: 500,
}));

export const WaiveBreakButton = styled(ModalButton)(({ theme }) => ({
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.background.translucentBlue,
  color: theme.colors.blue,
  '&:hover': {
    color: theme.colors.white,
    transform: 'translateY(-1px)',
  },
}));

export const WelcomeText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.colors.white,
}));

export const StatusText = styled(Typography)(({ theme }) => ({
  opacity: 0.9,
  maxWidth: '80%',
  lineHeight: 1.4,
  color: theme.colors.white,
}));
